/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

/**
 * Function to extract values from an object based on the header name, also if are nested.
 * @param obj Object- The object from which values are to be extracted.
 * @param  header String- The header or key path used to retrieve the value. 
 */
export const extractValueForHeader = (obj, header) => {
    if (header.includes('.')) {
        const keys = header.split('.');
        let value = obj;
        for (let key of keys) {
            value = value ? value[key] : undefined;
            if (value === undefined) {
                break;
            }
        }
        return value;
    }

    return obj[header];
};

/**
 * Function to format a timestamp into a localized date string.
 * @param  timestamp -number The timestamp in milliseconds
 */
export const formatDate = (timestamp) => {
    if (!timestamp) return '-';
    const date = new Date(timestamp);
    return date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
};
